import React from 'react';
import PropTypes from 'prop-types';
import { useApolloClient } from '@apollo/client';

import { platform_base_url } from '../../../../util/config';
import { post } from '../../../../util/request';
import { useFacebookSdk } from '../../Authentication.hooks';
import { completeAuthentication } from '../../Authentication.utils';
import SocialButton from '../../../SocialButton/SocialButton';

const FacebookLoginButton = ({ onComplete, setIsLoading }) => {
  const client = useApolloClient();
  const isFacebookReady = useFacebookSdk();

  const handleFacebookAuth = async () => {
    if (isFacebookReady) {
      window.FB?.login(
        (res) => {
          if (res.authResponse?.accessToken) {
            const { accessToken, userID } = res.authResponse;
            setIsLoading(true);
            post(
              `${platform_base_url}/v2/identity/social/facebook`,
              {
                access_token: accessToken
              },
              { credentials: 'include' }
            )
              .then(completeAuthentication.bind(null, client))
              .then(onComplete.bind(null, { id: userID, method: 'facebook' }));
          } else {
            // TODO: Handle caught error in toast or something?
          }
        },
        { scope: 'email' }
      );
    }
  };

  return <SocialButton provider="facebook" onClick={handleFacebookAuth} />;
};

FacebookLoginButton.propTypes = {
  /**
   * Callback on successful facebook login
   */
  onComplete: PropTypes.func.isRequired,
  /**
   * Updates the loading state of the form
   */
  setIsLoading: PropTypes.func.isRequired
};

export default FacebookLoginButton;
